import React from 'react'

export default function DisclaimerFooterList(props) {

    const {disclaimerList} = props

  if (!Array.isArray(disclaimerList) || disclaimerList.length === 0) return null;

  const middleIndex = Math.ceil(disclaimerList?.length / 2);
  const firstColumn = disclaimerList?.slice(0, middleIndex);
  const secondColumn = disclaimerList?.slice(middleIndex);

  return (
    <div className="container mt-20">
    <div className="flex w-full gap-4">
      <ul className="w-1/2 list-none">
        {firstColumn.map((item, index) => (
          <li key={index}><p style={{fontSize:"16px"}}><span style={{fontFamily: "SuzukiPROBold"}}>{item?.name}</span> {item?.description}</p></li>
        ))}
      </ul>
      <ul className="w-1/2 list-none">
        {secondColumn.map((item, index) => (
          <li key={index + middleIndex}><p style={{fontSize:"16px"}}><span style={{fontFamily: "SuzukiPROBold"}}>{item?.name}</span> {item?.description}</p></li>
        ))}
      </ul>
    </div>
    </div>
  )
}
